
console.log("process.env.NODE_ENV", process.env.NODE_ENV);
if (process.env.NODE_ENV == 'development') {
    //本地环境
    //  api_url= "http://huace.localhost.wlphp.com/api.php/index/index?"
     //api_url= "https://vhua.lizengtong.com/api.php/index/index?"
     api_url= "https://huaceapi.kuguanbang.com/api.php/index/index?"

} else if (process.env.NODE_ENV == 'testing') {
    //测试站
    api_url = "http://test.ghua.lizengtong.com/api.php/index/index?"
} else if (process.env.NODE_ENV == 'production') {
    //生产环境
    api_url= "https://huaceapi.kuguanbang.com/api.php/index/index?"
}

module.exports = {
    api_url
}



// WEBPACK FOOTER //
// ./src/config.js